/* Vortex theme script. No dependencies. Everything degrades to plain links and forms. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const cfg = window.vortex || { routes: {}, cartType: 'page' };

  /* ---------- header: scrolled state + height var ---------- */
  const setHeaderHeight = () => {
    const header = $('.site-header');
    if (header) document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
  };
  // header goes solid once you scroll, and tucks away while scrolling down (Nike-style)
  let lastY = window.scrollY;
  const onScroll = () => {
    const y = window.scrollY;
    document.body.classList.toggle('is-scrolled', y > 30);
    const busy = document.body.matches('.menu-open, .drawer-open, .search-open');
    if (!busy && Math.abs(y - lastY) > 6) {
      document.body.classList.toggle('header-hidden', y > lastY && y > 300);
      lastY = y;
    }
  };
  setHeaderHeight();
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setHeaderHeight);

  /* ---------- modal helpers ---------- */
  let lastFocus = null;
  const openLayer = (el, trigger, bodyClass) => {
    if (!el) return;
    lastFocus = trigger || document.activeElement;
    el.hidden = false;
    document.body.classList.add(bodyClass);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    const focusable = $('input:not([type=hidden]), button, a[href]', el);
    if (focusable) setTimeout(() => focusable.focus(), 30);
  };
  const closeLayer = (el, bodyClass) => {
    if (!el || el.hidden) return;
    el.hidden = true;
    document.body.classList.remove(bodyClass);
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  };

  // keep Tab inside whichever layer is open
  document.addEventListener('keydown', (e) => {
    const layer = $$('[role="dialog"]').find((d) => !d.hidden);
    if (!layer) return;
    if (e.key === 'Escape') {
      closeAll();
      return;
    }
    if (e.key !== 'Tab') return;
    const items = $$('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea', layer).filter(
      (n) => n.offsetParent !== null
    );
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  const menu = $('[data-menu-drawer]');
  const search = $('[data-search-overlay]');
  const closeAll = () => {
    closeLayer(menu, 'menu-open');
    closeLayer(search, 'search-open');
    $$('.drawer').forEach((d) => closeLayer(d, 'drawer-open'));
    $$('[data-film]').forEach((f) => {
      const v = f.querySelector('video');
      if (v) v.pause();
      closeLayer(f, 'drawer-open');
    });
  };

  document.addEventListener('click', (e) => {
    const t = e.target;
    const menuOpen = t.closest('[data-menu-open]');
    if (menuOpen) return openLayer(menu, menuOpen, 'menu-open');
    if (t.closest('[data-menu-close]')) return closeLayer(menu, 'menu-open');

    const searchOpen = t.closest('[data-search-open]');
    if (searchOpen) return openLayer(search, searchOpen, 'search-open');
    if (t.closest('[data-search-close]')) return closeLayer(search, 'search-open');

    const filtersOpen = t.closest('[data-filters-open]');
    if (filtersOpen) return openLayer($('[data-filters-drawer]'), filtersOpen, 'drawer-open');

    const cartOpen = t.closest('[data-cart-open]');
    if (cartOpen && cfg.cartType === 'drawer' && $('[data-cart-drawer]')) {
      e.preventDefault();
      return openLayer($('[data-cart-drawer]'), cartOpen, 'drawer-open');
    }

    if (t.closest('[data-drawer-close]')) return closeLayer(t.closest('.drawer'), 'drawer-open');
    // click on the dimmed backdrop
    if (t.classList && t.classList.contains('drawer')) return closeLayer(t, 'drawer-open');
  });

  // menu links to anchors on the same page should close the menu
  if (menu) menu.addEventListener('click', (e) => { if (e.target.closest('a')) closeLayer(menu, 'menu-open'); });

  /* ---------- reveal on scroll ---------- */
  window.vortexReady = true;
  document.documentElement.classList.add('js');
  const reveal = $$('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      }),
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    reveal.forEach((el) => io.observe(el));
  } else {
    reveal.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- forms that posted: bring the message into view ---------- */
  const posted = $('[data-autofocus]');
  if (posted) {
    posted.scrollIntoView({ block: 'center' });
    posted.focus({ preventScroll: true });
  }

  /* ---------- collection sort ---------- */
  $$('[data-autosubmit]').forEach((sel) => sel.addEventListener('change', () => {
    const form = sel.form || document.getElementById(sel.getAttribute('form'));
    if (form) form.submit();
  }));

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = $('input', step.closest('[data-qty]'));
    const min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + Number(step.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart: count, drawer, line updates ---------- */
  const setCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  };

  const sectionIdOf = (el) => {
    const wrap = el.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  };

  const swapSection = (id, html) => {
    const wrap = document.getElementById(`shopify-section-${id}`);
    if (!wrap || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById(`shopify-section-${id}`);
    const wasOpen = wrap.querySelector('.drawer') && !wrap.querySelector('.drawer').hidden;
    wrap.innerHTML = fresh ? fresh.innerHTML : html;
    const drawer = wrap.querySelector('.drawer');
    if (drawer && wasOpen) drawer.hidden = false;
  };

  const changeLine = async (el, line, quantity) => {
    const id = sectionIdOf(el);
    const layer = el.closest('.drawer') || el.closest('[data-cart-page]');
    if (layer) layer.classList.add('is-busy');
    try {
      const res = await fetch(cfg.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: id ? [id] : [] }),
      });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || 'Could not update the bag');
      setCount(cart.item_count);
      if (id && cart.sections) swapSection(id, cart.sections[id]);
    } catch (err) {
      window.location.reload();
    }
  };

  let qtyTimer;
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(() => changeLine(input, Number(input.dataset.lineQty), Number(input.value)), 350);
  });

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(remove, Number(remove.dataset.lineRemove), 0);
  });

  /* ---------- product: variant picker ---------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('[data-product-json]', root);
    const form = $('[data-product-form]', root);
    if (!dataEl || !form) return;
    const { variants } = JSON.parse(dataEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-button]', form);
    const addLabel = $('[data-add-label]', form);
    const amount = $('[data-amount]', root);
    const compare = $('[data-compare]', root);
    const fieldsets = $$('.option', form);

    const selected = () => fieldsets.map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    const update = () => {
      const opts = selected();
      fieldsets.forEach((fs, i) => { const v = $('[data-option-value]', fs); if (v) v.textContent = opts[i] || ''; });
      const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (amount) amount.textContent = variant.price;
      if (compare) {
        compare.hidden = !variant.compare;
        compare.textContent = variant.compare || '';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (variant.media) {
        const media = $(`[data-media-id="${variant.media}"]`, root);
        const gallery = $('[data-gallery]', root);
        if (media && gallery) {
          if (window.matchMedia('(max-width: 989px)').matches) {
            gallery.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
          } else if (!media.classList.contains('is-first')) {
            media.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
    };
    fieldsets.forEach((fs) => fs.addEventListener('change', update));

    // mobile gallery dots
    const gallery = $('[data-gallery]', root);
    const dots = $$('.product__dots span', root);
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      }, { passive: true });
    }
  });

  /* ---------- add to bag ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || cfg.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
    e.preventDefault();
    const btn = $('[data-add-button]', form);
    const label = $('[data-add-label]', form);
    const errorEl = $('[data-form-error]', form);
    const original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding…';
    errorEl.hidden = true;

    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    try {
      const res = await fetch(cfg.routes.cartAdd, { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
      swapSection('cart-drawer', data.sections && data.sections['cart-drawer']);
      const cart = await fetch(`${cfg.routes.cart}.js`).then((r) => r.json());
      setCount(cart.item_count);
      openLayer($('[data-cart-drawer]'), btn, 'drawer-open');
    } catch (err) {
      errorEl.textContent = err.message;
      errorEl.hidden = false;
    } finally {
      btn.disabled = false;
      label.textContent = original;
    }
  });


  /* ---------- tabs (Trending now) ---------- */
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[data-tab]', root);
    const panels = $$('[data-panel]', root);
    const show = (i) => {
      tabs.forEach((t, k) => { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach((p, k) => { p.hidden = k !== i; });
      window.dispatchEvent(new Event('resize')); // let the carousel re-measure the newly shown row
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => show(i));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          show(n);
          tabs[n].focus();
        }
      });
    });
  });

  /* ---------- carousels: arrow buttons scroll the track ---------- */
  $$('[data-carousel]').forEach((root) => {
    const track = $('[data-carousel-track]', root);
    const prev = $('[data-carousel-prev]', root);
    const next = $('[data-carousel-next]', root);
    if (!track || !prev || !next) return;
    const step = () => {
      const card = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const per = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      // move by whole cards so the row always lands on an edge
      return Math.max(per, Math.floor((track.clientWidth - 40) / per) * per);
    };
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      root.classList.toggle('is-static', max <= 0);
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- card color swatches ---------- */
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('[data-swatch]');
    if (!dot) return;
    const card = dot.closest('.card');
    const img = card && $('.card__img--main', card);
    $$('[data-swatch]', card).forEach((d) => d.classList.toggle('is-active', d === dot));
    if (img && dot.dataset.src) {
      img.srcset = dot.dataset.srcset || '';
      img.src = dot.dataset.src;
    }
    if (dot.dataset.href) $$('.card__media, .card__title', card).forEach((a) => { a.href = dot.dataset.href; });
  });

  /* ---------- story banner slideshow ---------- */
  $$('[data-slideshow]').forEach((show) => {
    const slides = $$('[data-slide]', show);
    const dots = $$('[data-slide-dot]', show);
    if (slides.length < 2) return;
    let i = 0;
    let timer;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const play = () => {
      clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => go(i + 1), 5500);
    };
    dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.slideDot)); play(); }));
    play();
  });

  /* ---------- journey: scroll walks the player across ---------- */
  $$('[data-journey]').forEach((root) => {
    const chapters = $$('[data-chapter]', root);
    const fits = $$('[data-fit]', root);
    const rail = $$('[data-rail]', root);
    const cuts = $$('.journey__cut', root);
    const video = $('.journey__video', root);
    const scrub = root.dataset.mode === 'scrub';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let active = -1;
    let stillTimer;

    if (video && scrub) video.pause();

    const walker = $('[data-walker]', root);
    const fitsWrap = $('.journey__fits', root);
    const mobile = window.matchMedia('(max-width: 749px)');
    // keep the outfit cards beside the player: on its right for the first half, then on its left
    const placeFits = (p) => {
      if (!walker || !fitsWrap || mobile.matches || scrub) {
        if (fitsWrap) fitsWrap.style.removeProperty('--fit-x');
        return;
      }
      const w = walker.offsetWidth;
      const x = p * (window.innerWidth - w);
      const cards = fitsWrap.offsetWidth || 280;
      const left = p < 0.5 ? x + w * 0.8 : x + w * 0.2 - cards;
      fitsWrap.style.setProperty('--fit-x', `${Math.round(Math.max(16, Math.min(window.innerWidth - cards - 16, left)))}px`);
    };

    const setChapter = (n) => {
      if (n === active) return;
      active = n;
      chapters.forEach((c, k) => {
        c.classList.toggle('is-active', k === n);
        c.classList.toggle('is-past', k < n);
      });
      fits.forEach((f, k) => f.classList.toggle('is-active', k === n));
      rail.forEach((r, k) => r.classList.toggle('is-active', k <= n));
      if (cuts.length) cuts.forEach((c) => c.classList.toggle('is-active', Number(c.dataset.chapterImg) === n));
    };

    const update = () => {
      const rect = root.getBoundingClientRect();
      const room = root.offsetHeight - window.innerHeight;
      const p = room > 0 ? Math.min(1, Math.max(0, -rect.top / room)) : 0;
      if (!reduced) root.style.setProperty('--walk', scrub ? 0 : p.toFixed(4));
      placeFits(p);
      setChapter(Math.min(chapters.length - 1, Math.floor(p * chapters.length)));
      if (video && scrub && video.duration) video.currentTime = p * (video.duration - 0.05);
      // the stand-in figure only strides while the page is moving
      root.classList.remove('is-still');
      clearTimeout(stillTimer);
      stillTimer = setTimeout(() => root.classList.add('is-still'), 180);
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        if (en.isIntersecting) {
          window.addEventListener('scroll', onScroll, { passive: true });
          if (video && !scrub) video.play().catch(() => {});
        } else {
          window.removeEventListener('scroll', onScroll);
          if (video && !scrub) video.pause();
        }
      }).observe(root);
    }
    update();

    const film = $('[data-film]', root);
    const watch = $('[data-watch]', root);
    if (film && watch) {
      const filmVideo = $('video', film);
      watch.addEventListener('click', () => {
        openLayer(film, watch, 'drawer-open');
        if (filmVideo) filmVideo.play().catch(() => {});
      });
      const close = () => { if (filmVideo) filmVideo.pause(); closeLayer(film, 'drawer-open'); };
      $('[data-film-close]', film).addEventListener('click', close);
      film.addEventListener('click', (e) => { if (e.target === film) close(); });
    }
  });

  /* ---------- related products ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.children.length) el.innerHTML = fresh.innerHTML;
    } catch (err) {
      /* related products are optional */
    }
  });
})();
